import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.519 6.406C2.646 7.25 1 8.62 1 10.5v5c0 1.882 1.645 3.252 3.518 4.095 1.256.565 2.79.982 4.482 1.209v.696c0 1.882 1.645 3.252 3.518 4.095C14.484 26.479 17.13 27 20 27s5.516-.52 7.482-1.405C29.355 24.752 31 23.382 31 21.5v-5c0-1.654-1.286-2.91-2.811-3.74-1.377-.75-3.178-1.291-5.189-1.565V10.5c0-1.881-1.646-3.251-3.519-4.094C17.515 5.521 14.87 5 12 5c-2.87 0-5.515.521-7.481 1.406m.82 1.824C3.592 9.016 3 9.896 3 10.5s.592 1.484 2.34 2.27c.792.357 1.746.654 2.817.867l.073.015c1.144.222 2.418.348 3.77.348a20 20 0 0 0 3.843-.363c1.07-.213 2.025-.51 2.818-.867C20.408 11.984 21 11.104 21 10.5s-.592-1.484-2.34-2.27C17.009 7.486 14.654 7 12 7s-5.008.486-6.66 1.23M15 15.803A23 23 0 0 1 12 16a23 23 0 0 1-3-.197v2.98c.936.14 1.944.217 3 .217s2.064-.077 3-.216zm2 2.56v-2.934a14.4 14.4 0 0 0 2.481-.835A9.3 9.3 0 0 0 21 13.74V15.5c0 .605-.592 1.485-2.338 2.27-.495.223-1.052.423-1.662.593m-2 3.067a16 16 0 0 1-1.593-.472 23 23 0 0 1-2.407.02v.522c0 .605.592 1.485 2.338 2.27.495.223 1.053.423 1.662.593zm2 3.354v-2.981c.956.128 1.963.197 3 .197s2.044-.068 3-.196v2.98c-.936.14-1.944.216-3 .216s-2.064-.077-3-.216M7 15.429a14.4 14.4 0 0 1-2.481-.835A9.3 9.3 0 0 1 3 13.74V15.5c0 .605.592 1.485 2.338 2.27.495.223 1.052.423 1.662.593zm22 1.066v.012c-.005.605-.599 1.481-2.338 2.264-.79.355-1.741.652-2.809.865A19.923 19.923 0 0 1 20 20q-.72 0-1.407-.047.465-.167.89-.358C21.354 18.752 23 17.382 23 15.5v-2.284c1.714.258 3.173.723 4.233 1.3 1.33.723 1.764 1.458 1.767 1.979m-4 4.935v2.933c.61-.17 1.167-.37 1.662-.592C28.408 22.985 29 22.105 29 21.5v-1.757a9.3 9.3 0 0 1-1.518.852c-.74.332-1.575.614-2.482.835"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconAllowances = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconAllowances);
export default Memo;
